import { render } from "./DesktopView.vue?vue&type=template&id=d8a32bdc"
import script from "./DesktopView.vue?vue&type=script&lang=js"
export * from "./DesktopView.vue?vue&type=script&lang=js"

import "./DesktopView.vue?vue&type=style&index=0&id=d8a32bdc&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__